/**
 * Resolve a manufacturer-site URL for a catalog product.
 *
 * Most brands store a PDP on `detailedLink` (`source.sourceUrl`). ProMaster's
 * API feed has no storefront URL, so we fall back to their Shopify search by
 * product code: https://promaster.com/search?q=89349
 */

const PROMASTER_SEARCH_BASE = 'https://promaster.com/search?q=';

function normalizeBrandKey(value?: string): string {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');
}

export function isPromasterProduct(product: {
  brand?: string;
  vendorId?: string;
  vendorName?: string;
  source?: string;
  id?: string;
}): boolean {
  const brand = normalizeBrandKey(product.brand);
  if (brand === 'promaster' || brand === 'promastersystems') return true;
  if (normalizeBrandKey(product.vendorId) === 'promaster') return true;
  const vendorName = normalizeBrandKey(product.vendorName);
  if (vendorName === 'promaster' || vendorName === 'promastersystems') return true;
  if (normalizeBrandKey(product.source) === 'promaster') return true;
  return String(product.id || '')
    .toLowerCase()
    .startsWith('promaster_');
}

function promasterProductCode(product: { sku?: string; mpn?: string; id?: string }): string {
  const fromFields = String(product.sku || product.mpn || '').trim();
  if (fromFields) return fromFields;
  const id = String(product.id || '');
  if (id.toLowerCase().startsWith('promaster_')) return id.slice('promaster_'.length);
  return '';
}

export function manufacturerSiteUrl(product: {
  detailedLink?: string;
  proSiteUrl?: string;
  brand?: string;
  vendorId?: string;
  vendorName?: string;
  source?: string;
  sku?: string;
  mpn?: string;
  id?: string;
}): string | undefined {
  const direct = String(product.detailedLink || '').trim();
  if (direct) return direct;

  if (isPromasterProduct(product)) {
    const code = promasterProductCode(product);
    if (code) return `${PROMASTER_SEARCH_BASE}${encodeURIComponent(code)}`;
  }

  const pro = String(product.proSiteUrl || '').trim();
  return pro || undefined;
}
